// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2pL9o","content":"Consent_content__2pSdz","footer":"Consent_footer__1_Pz-"};